import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=2e3b8b6a&"
import script from "./Admin.vue?vue&type=script&setup=true&lang=js&"
export * from "./Admin.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports